import {useEffect, useRef} from 'react';

export const useOuterClick = (onOuterClick, innerRef) => {
  useEffect(() => {
    if (innerRef.current) {
      document.addEventListener("click", handleClick);
    }

    return () => document.removeEventListener("click", handleClick);

    function handleClick(e) {
      innerRef.current
      && !innerRef.current.contains(e.target)
      && onOuterClick
      && onOuterClick(e);
    }
  }, [onOuterClick, innerRef]);
};

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value
  });
  return ref.current;
};